import { useEffect, useState } from 'react';

const SCRIPT_ID = 'facebook-jssdk';
const SDK_VERSION = 'v18.0';

/**
 * Loads the Facebook SDK script and initializes it with the given app ID.
 * Returns { isReady: true } when FB is available and initialized.
 */
export function useFacebookSdk(appId: string | undefined): { isReady: boolean } {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (!appId) return;

    const init = () => {
      if (!window.FB) return;
      window.FB.init({
        appId,
        cookie: true,
        xfbml: true,
        version: SDK_VERSION,
      });
      if (window.FB.AppEvents) {
        window.FB.AppEvents.logPageView();
      }
      setIsReady(true);
    };

    if (window.FB) {
      init();
      return;
    }

    if (document.getElementById(SCRIPT_ID)) {
      window.fbAsyncInit = init;
      return;
    }

    window.fbAsyncInit = init;
    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.async = true;
    script.defer = true;
    script.src = 'https://connect.facebook.net/en_US/sdk.js';
    script.crossOrigin = 'anonymous';
    const firstScript = document.getElementsByTagName('script')[0];
    firstScript?.parentNode?.insertBefore(script, firstScript);

    return () => {
      window.fbAsyncInit = undefined;
    };
  }, [appId]);

  return { isReady };
}
